import { createFileRoute, redirect } from '@tanstack/react-router';

import { trpcVanilla } from '@/lib/trpc/shared';

export const Route = createFileRoute('/_app/dashboard/')({
  beforeLoad: async () => {
    const me = await trpcVanilla.user.me.query().catch(() => null);
    if (!me) {
      throw redirect({ to: '/sign-in' });
    }
    if (me.status !== 'ACTIVE') {
      throw redirect({ to: '/sign-in' });
    }
    if (me.role === 'BIDDER') {
      if (me.bidderType === 'COMPANY') {
        throw redirect({ to: '/dashboard/bidder/company' });
      }
      throw redirect({ to: '/dashboard/bidder/individual' });
    }
    throw redirect({ to: '/dashboard/requester' });
  },
});
